
export const ColorGreen="#01B1A8";
export const ColorOrange1="#843C0C";
export const ColorOrange ="palevioletred";//"#FF0066";
export const ColorYellowDark="darkgoldenrod";